import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = true
}: ButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-montserrat font-black text-brand-dark bg-brand-accent rounded-md px-4 py-3 md:px-6 md:py-4 text-base md:text-lg lg:text-xl text-center uppercase tracking-wide border-b-4 border-brand-accentDark active:border-b-0 active:translate-y-1 transition-all';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (!href) {
      scrollToCompra(e);
    }
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${widthClasses} ${className}`} data-id="element-27">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${widthClasses} ${className}`} data-id="element-28">
      {children}
    </button>;
}